import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import styled from '@emotion/styled'
import { Power4 } from 'gsap'
import { Location } from '@reach/router'
import route from 'path-match'
import Menu from '@material-ui/core/Menu'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import WithStylesProps from '@/hoc/WithStylesProps'
import { easing } from '@/utils/preset'
import { mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import TextButton from '@/components/common/TextButton'
import { Link } from 'gatsby'
import * as MenuItem from '@/components/common/MenuItem'

class Nav extends React.Component {
  constructor (props) {
    super(props)
    const state = {}
    props.routes.main.filter(route => {
      return route.childLists
    }).forEach(route => {
      state[route.path] = null
    })
    this.state = state
  }
  handleMenuClick = path => {
    return event => {
      const state = {
        ...this.state
      }
      state[path] = event.currentTarget
      this.setState(state)
    }
  }
  handleMenuClose = path => {
    return event => {
      const state = {
        ...this.state
      }
      state[path] = null
      this.setState(state)
    }
  }
  handleLinkClick = (event, path) => {
    if (path.indexOf('#') === -1) {
      return
    }
    event.preventDefault()
    const id = path.substring(path.indexOf('#') + 1)
    if (!document.getElementById(id)) {
      return
    }
    const scrollEl = this.props.mediaType === 'tabletS'
      ? document.getElementById('root')
      : document.getElementById('left')
    const header = document.getElementById('header')
    window.TweenMax.to(scrollEl, 0.6, {
      ease: Power4.easeInOut,
      scrollTo: {
        y: `#${id}`,
        offsetY: header.offsetHeight
      }
    })
  }
  render () {
    const { theme, routes, classes, ...other } = this.props
    return (
      <Root theme={theme} {...other}>
        <Row>
          <PageList>
            {routes.main.map((item, index) => {
              const match = route({ start: true, end: false })(item.path)
              return (
                <Location key={index}>
                  {({ navigate, location }) => (
                    <PageList_Child>
                      {item.childLists && (
                        <Fragment>
                          <Menu
                            open={Boolean(this.state[item.path])}
                            onClose={this.handleMenuClose(item.path)}
                            anchorEl={this.state[item.path]}>
                            <MenuItem.default
                              classes={{ ...MenuItem.get(classes) }}
                              component={Link}
                              to={item.path}
                              onClick={this.handleMenuClose(item.path)}>
                              {item.title}トップ
                            </MenuItem.default>
                            {item.childLists.map((child, index) => {
                              return (
                                <MenuItem.default
                                  classes={{ ...MenuItem.get(classes) }}
                                  key={index}
                                  component={Link}
                                  to={child.path}
                                  onClick={this.handleMenuClose(item.path)}>
                                  {child.title}
                                </MenuItem.default>
                              )
                            })}
                          </Menu>
                          <PageLink
                            onClick={this.handleMenuClick(item.path)}>
                            {item.title}
                            <PageLink_Arrow className={match(location.pathname) ? 'active' : false} width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 0L0 8L16 8L8 0Z" fill="currentColor"/>
                            </PageLink_Arrow>
                          </PageLink>
                        </Fragment>
                      )}
                      {!item.childLists && (
                        <PageLink
                          to={item.path}
                          component={Link}
                          size="small"
                          onClick={e => this.handleLinkClick(e, item.path)}
                        >
                          {item.title}
                          <PageLink_Arrow className={match(location.pathname) ? 'active' : false} width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0L0 8L16 8L8 0Z" fill="currentColor"/>
                          </PageLink_Arrow>
                        </PageLink>
                      )}
                    </PageList_Child>
                  )}
                </Location>
              )
            })}
          </PageList>
        </Row>
      </Root>
    )
  }
}

const Root = styled.nav`
  display: flex;
  justify-content: space-between;
  @media ${mq.and(mobile)} {
    display: none;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &:not(:first-of-type) {
    margin-left: ${rem(24)};
  }
`

const PageList = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${rem(56)};
`

const PageList_Child = styled.li`
  text-align: center;
  margin: 0 ${rem(4)};
`

const PageLink = styled(TextButton)`
`

const PageLink_Arrow = styled.svg`
  display: block;
  position: absolute;
  left: 50%;
  bottom: ${rem(-10)};
  margin-left: ${rem(-8)};
  opacity: 0;
  transform: translateY(${rem(2)});
  transition:
    opacity 0.2s ${easing.css.easeInOutExpo},
    transform 0.2s ${easing.css.easeInOutExpo};
  &.active {
    opacity: 1;
    transform: translateY(0);
  }
`

const make = props => {
  return {
    ...MenuItem.make(props)
  }
}

const mapStateToProps = state => {
  return {
    mediaType: state.UI.Window.mediaType
  }
}

export default ThemeConsumer(WithStylesProps(make)(connect(
  mapStateToProps
)(Nav)))
